import { render, staticRenderFns } from "./YesNoDialog.vue?vue&type=template&id=3a31234a&scoped=true"
import script from "./YesNoDialog.vue?vue&type=script&lang=ts"
export * from "./YesNoDialog.vue?vue&type=script&lang=ts"
import style0 from "./YesNoDialog.vue?vue&type=style&index=0&id=3a31234a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a31234a",
  null
  
)

export default component.exports